'use client';
import { ReactNode } from 'react';

interface ListProps {
  children: ReactNode;
  className?: string;
  gap?: string;
  direction?: 'row' | 'column';
  maxWidth?: string;
}

const List = ({ 
  children, 
  className = '',
  gap = 'gap-[14px]',
  direction = 'row',
  maxWidth = 'max-w-[1140px]'
}: ListProps) => {
  const directionClass = direction === 'row' ? 'flex-row' : 'flex-col'; // Add missing semicolon
  
  return (
    <div data-component-id="src/components/common/List.tsx:22:4" data-component-path="src/components/common/List.tsx" data-component-line="22" data-component-file="List.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`flex ${directionClass} ${gap} w-full ${maxWidth} ${className}`}>
      {children}
    </div>
  ); // Add missing semicolon
};

export default List; // Add missing semicolon